import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import BetSlipWager from '../layoutComponents/BetSlipWager';
import { makeWager as makeWagerApi } from '../../api-calls/wagers';
import { makeWager as makeContractWager } from '../../contract/WagersController';
import { Icon, message } from 'antd';
const ethMultiplier = 1000000000000000000;
@observer(["BetSlipStore", "web3Store", "eventStore", "WagerStore", "UserStore", "AuthStore"])
class BetSlip extends Component {
  constructor(props) {
    super(props);


    this.state = {
      betSlipVisible: false,
      submittingBets: false,
    };
    this.handleBetStepsStatus = this.handleBetStepsStatus.bind(this);
    this.submitAllBets = this.submitAllBets.bind(this);


  }
  handleBetStepsStatus() {
    const { BetSlipStore } = this.props;

    BetSlipStore.showHideBetSlip();
  }

  submitAllBets() {
    this.setState({ submittingBets: true });

    const { web3Store, AuthStore, UserStore, WagerStore, BetSlipStore } = this.props;
    let self = this;

    let authToken = AuthStore.userAuth.auth.accessToken;
    let userId = UserStore.user._id;
    let timeNow = new Date().getTime() / 1000;


    for (let wager of BetSlipStore.WagerList.wagers) {
      if (wager.eventStartTime + wager.eventDuration > timeNow) {
        // let amount = String(wager.value * ethMultiplier);
        // let stringAmount = String(amount);
        makeContractWager(wager.bytes32Id, wager.eventBytes32Id, wager.value, wager.odds, wager.makerChoice).then( //SUBTRACT 1 from maker choice becasue contract (0= team one) and (1= team 2)
          function (result) {
            if (String(result).includes('User denied transaction signature')) {
              message.warning("Metamask transaction denied! No bet made.");
              self.setState({ submittingBets: false });
              BetSlipStore.showBetSlip();
            } else {
              return makeWagerApi(authToken,
                userId,
                wager.bytes32Id,
                wager.eventId,
                web3Store.account,
                wager.value,
                wager.odds,
                wager.makerChoice,
                false,
                false,
                wager.isPropWager,
                wager.originalEventId,
                wager.isPrivate).then(() => {
                  self.setState({ submittingBets: false });
                }).then(function () {
                  if (!wager.isPropWager) {
                    WagerStore.queryEventWagers(wager.eventId);
                  }
                  BetSlipStore.resetStore();
                  return UserStore.updateUserBets(AuthStore.userAuth.auth.accessToken);
                })
            }
          });
      }
    }
    BetSlipStore.hideBetSlip();
  }

  render() {
    const { BetSlipStore, AuthStore } = this.props;

    let amountOfWagers = "";

    let betList = <div style={{ padding: '10px' }}>No bets yet</div>

    if (BetSlipStore.WagerList.totalWagersAmount() !== 0) {
      amountOfWagers = <div className="bet-slip-header-wagers-amount-circle">
        {BetSlipStore.WagerList.totalWagersAmount()}
      </div>
      if (this.state.submittingBets) {
        betList = <div style={{ padding: '10px' }}><Icon type="loading" /> Submitting bets</div>
      }
      else {
        betList = <ul>
          {BetSlipStore.WagerList.wagers.map((wager, i) => (
            <BetSlipWager wager={wager} key={i} />
          ))}
        </ul>
      }
    }

    let betStepOpenClose = "bet-slip-closed";
    let openCloseButton = <span style={{ color: '#27f727' }}><Icon type="plus-circle" theme="outlined" /></span>

    if (BetSlipStore.getBetSlipStatus()) {
      if (BetSlipStore.WagerList.totalWagersAmount() == 0) {
        betStepOpenClose = "bet-slip-empty";
      } else {
        betStepOpenClose = "bet-slip-open";
      }
      openCloseButton = <span style={{ color: '#ff4d4f' }}><Icon type="minus-circle" theme="outlined" /></span>

    }

    let loginSubmitButton = <div style={{
      paddingTop: '14px',
      letterSpacing: '2px',
      textTransform: 'uppercase',
      fontWeight: '100'
    }}>Login to make bets</div>
    if (AuthStore.userAuth.auth) {
      if (BetSlipStore.WagerList.totalWagersAmount() == 0) {
        loginSubmitButton = <button disabled className="custom-btn-disabled">Submit bets</button>
      } else {
        loginSubmitButton = <button className="custom-btn-primary" onClick={this.submitAllBets}>Submit bets</button>

      }
    }
    return (
      <div className={betStepOpenClose}>
        <div onClick={this.handleBetStepsStatus} id="bet-slip-header" className="bet-slip-header">
          <div className="bet-slip-header-title">Bet Slip {amountOfWagers}</div>
          {openCloseButton}
        </div>
        <div className="bet-slip-content">
          {betList}
        </div>
        <div className="bet-slip-info">
          <div>Total Stake: <span>{(BetSlipStore.WagerList.totalStakeAmount() / ethMultiplier).toFixed(4)} ETH</span></div>
          <div> Total potential win: <span>{(BetSlipStore.WagerList.totalPotentialWinAmount() / ethMultiplier).toFixed(4)} ETH</span> MINUS FEES</div>
        </div>
        <div className="bet-slip-footer">
          {loginSubmitButton}
        </div>
      </div>
    );
  }
}

export default observer(BetSlip);



// WEBPACK FOOTER //
// ./src/components/appComponents/BetSlip.js